// Default Subjectivities for builders risk submissions

export const DEFAULT_BR_SUBJECTIVITIES: string[] = [
    'Scope of work',
    'General Contractor information',
    'Site Plan and Elevation Plans and/or 3-D sketches in lieu of Elevation Plans',
    'Schedule (Level 2 Gantt chart)',
    'Geotech Report',
    'Detailed Hard Cost Budget',
    'Itemized Soft Costs',
    'Proforma Loss of Rents statement',
    'Project specific loss control plan (e.g. Hot Works, No Smoking policy, etc.)',
    'Site Security Plan',
    'Water flow detection system/vendor (only if the insured is utilizing one)',
    'Lead Insurer forms (only if Lumen is following a lead)',
    'Engineering Condition Report and Replacement Cost Valuation (only if this account is a renovation project)',
];
